<template>
  <section
    class="industry-benefit-text-box no-flicker"
    :class="{ active: active }"
    :style="{
      bottom: textBox.position.bottom + '%',
      left: textBox.position.left + '%'
    }"
  >
    <div class="industry-benefit-text-box__exit-area">
      <div
        class="industry-benefit-text-box__exit-area__industry-benefit-text-box-button"
        @click="endAnimation"
      >
        <p
          class="font industry-benefit-text-box__exit-area__industry-benefit-text-box-button__exit"
        >EXIT</p>
        <img
          class="industry-benefit-text-box__exit-area__industry-benefit-text-box-button__icon"
          :src="exitIcon"
          alt
        />
      </div>
    </div>
    <div class="industry-benefit-text-box__text-area">
      <div class="industry-benefit-text-box__text-area__wrapper">
        <div class="industry-benefit-text-box__text-area__wrapper__benefits">
          <div
            v-for="(benefit, i) in textBox.text"
            :key="i"
            class="industry-benefit-text-box__text-area__wrapper__benefits__benefit"
          >
            <div class="industry-benefit-text-box__text-area__wrapper__benefits__benefit__text">
              <p class="font--semibold">{{ benefit.text }}</p>
            </div>
            <img
              class="industry-benefit-text-box__text-area__wrapper__benefits__benefit__icon"
              :src="getIcon(benefit.icon)"
              alt
            />
          </div>
        </div>
      </div>
    </div>

    <div class="industry-benefit-text-box__next-area">
      <div class="industry-benefit-text-box__next-area__industry-benefit-text-box-button">
        <p
          class="font industry-benefit-text-box__next-area__industry-benefit-text-box-button__next"
        >INDUSTRY BENEFIT</p>
      </div>
      <div
        class="industry-benefit-text-box__next-area__industry-benefit-text-box-button-continue"
        @click="onNext"
      >
        <p
          class="font industry-benefit-text-box__next-area__industry-benefit-text-box-button-continue__next"
        >NEXT</p>
        <img
          class="industry-benefit-text-box__next-area__industry-benefit-text-box-button-continue__icon"
          :src="nextArrowIcon"
          alt
        />
      </div>
    </div>
  </section>
</template>

<script>
import nextArrowIcon from "@/assets/text-box-accents/next-arrow.svg";
import exitIcon from "@/assets/text-box-accents/exit-icon.svg";

import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "industry-benefit-text-box",
  props: [
    "textBox",
    "onClose",
    "onFinish",
    "next",
    "updated",
    "continueAnimation",
    "lastTextBox",
    "previousProgress",
    "animationProgress",
    "active"
  ],
  data() {
    return {
      nextArrowIcon,
      exitIcon,
      i: 0,
      typeTimeOuts: [],
      progressMotion: this.previousProgress
    };
  },
  computed: {
    ...mapState({
      voiceOverTime: state => state.moduleMacroAnimations.voiceOverTime,
      totalVoiceOverTime: state =>
        state.moduleMacroAnimations.totalVoiceOverTime,
      totalWaitTime: state => state.moduleMacroAnimations.totalWaitTime,
      waitProgress: state => state.moduleMacroAnimations.waitProgress,
      voiceOver: state => state.audio.voiceOver,
      currentAnimationName: state => state.analytics.currentAnimationName,
      currentVoiceOverName: state => state.analytics.currentVoiceOverName
    })
  },
  methods: {
    ...mapMutations([
      "updateWaitProgress",
      "updateTotalWaitTime",
      "setVoiceOver",
      "updateStopTimeIdx",
      "updateShowAmbientAnimations"
    ]),
    endAnimation() {
      this.$ga.event({
        eventCategory: "Macro Animation",
        eventAction: "Canceled Selection",
        eventLabel: `CANCELED_STORY_TEXTBOX: ${this.currentAnimationName} was canceled at ${this.currentVoiceOverName} `,
        eventValue: 1
      });
      this.updateShowAmbientAnimations(true);
      if (this.voiceOver) {
        this.voiceOver.pause();
        this.setVoiceOver(undefined);
      }
      this.updateWaitProgress(0);
      this.onClose();

      this.updateStopTimeIdx(-1);
    },
    finishAnimation() {
      this.$ga.event({
        eventCategory: "Macro Animation",
        eventAction: "Skipped Selection",
        eventLabel: `SKIPPED_STORY_TEXTBOX: ${this.currentAnimationName} was skipped at ${this.currentVoiceOverName} `,
        eventValue: 1
      });
      if (this.voiceOver) {
        this.voiceOver.pause();
        this.setVoiceOver(undefined);
      }
      this.updateWaitProgress(0);
      this.onFinish();

      this.updateStopTimeIdx(-1);
    },
    onNext() {
      this.$ga.event({
        eventCategory: "Macro Animation",
        eventAction: "Skipped Selection",
        eventLabel: `SKIPPED_STORY_TEXTBOX: ${this.currentAnimationName} was skipped at ${this.currentVoiceOverName} `,
        eventValue: 1
      });
      if (this.voiceOver) {
        this.voiceOver.pause();
        this.setVoiceOver(undefined);
      }
      this.next();
    },
    clearDelayTimeout() {
      for (let timeout of this.typeTimeOuts) {
        clearTimeout(timeout);
      }
    },
    getIcon(pic) {
      if (pic) {
        var image = require.context("@/assets/benefit_icons/", false);
        return image("./" + pic);
      }
    }
  },
  destroyed() {
    this.$destroy();
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_vars";

.industry-benefit-text-box {
  opacity: 1;
  position: absolute;
  width: 11vw;
  height: 6vw;
  &__exit-area {
    position: relative;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 13%;
    &__industry-benefit-text-box-button {
      cursor: pointer;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      &__exit {
        color: $color-white;
        font-size: 0.4vw;
        margin-right: 0.3vw;
      }
      &__icon {
        height: 0.55vw;
        width: 0.55vw;
        margin-right: 0.3vw;
      }
    }
  }
  &__text-area {
    position: relative;
    width: 100%;
    height: 74%;
    background-color: $color-white;
    &__wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      padding: 3%;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: flex-start;

      &__benefits {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: center;
        align-items: center;
        &__benefit {
          position: relative;
          width: 50%;
          height: 100%;
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          justify-content: center;
          align-content: center;
          align-items: center;
          &__icon {
            z-index: 0;
            width: 54.5%;
            height: 75%;
            margin-top: 2%;
            margin-left: 1%;
            img {
              width: 100%;
              height: 100%;
            }
          }
          &__text {
            font-size: 0.4vw;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-content: center;
            align-items: center;
            text-align: center;
          }
        }
      }
    }
  }

  &__next-area {
    height: 13%;
    display: flex;
    justify-content: space-between;
    background-color: $color-black-transparent;
    &__industry-benefit-text-box-button {
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      &__next {
        color: $color-lime-bright;
        font-size: 0.4vw;
        margin-left: 0.3vw;
      }
    }
    &__industry-benefit-text-box-button-continue {
      cursor: pointer;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      &__next {
        color: $color-lime-bright;
        font-size: 0.4vw;
        margin-right: 0.3vw;
      }
      &__icon {
        height: 0.55vw;
        width: 0.55vw;
        margin-right: 0.3vw;
      }
    }
  }
}
</style>
